module.exports = __webpack_public_path__ + "static/media/banner-0-my.2e359dea.jpg";